var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"pbiComponent",staticClass:"divHeight",attrs:{"id":"pbiComponent"}})
}
var staticRenderFns = []

export { render, staticRenderFns }